class ConciergeDrawer extends HTMLElement {
  constructor() {
    super()

    this.drawer = this.closest('.drawer')
    this.chatToggle = this.querySelector('.chat-toggle')
    this.mainWrapper = document.querySelector('#MainContent')
    this.accordions = this.querySelectorAll('.concierge__accordion')
    this.appointmentToggle = this.querySelector('.book-appointment')
    this.appointmentForm = this.querySelector('#schedule-appointment')
    this.accordionTriggers = this.querySelectorAll('.concierge__accordion-trigger')

    this.accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (!trigger.closest('.concierge__accordion').classList.contains('open')) {
          this.closeAllAccordions()
        }
        this.toggleAccordion(trigger)
      })
    })

    this.chatToggle.addEventListener('click', this.closeConcierge.bind(this))
    this.appointmentToggle.addEventListener('click', this.scrollToAppointment.bind(this))
  }

  toggleAccordion(trigger) {
    const wrapper = trigger.closest('.concierge__accordion')
    const content = wrapper.querySelector('.concierge__accordion-content')
    const paragraphs = wrapper.querySelectorAll('.concierge__accordion-content > *')

    if (wrapper.classList.contains('open')) {
      content.style.maxHeight = `${0}px`
      setTimeout(() => {
        content.style.maxHeight = ''
        wrapper.classList.remove('open')
      }, 401)
    } else {
      content.classList.add('changing')
      content.classList.remove('changing')
      wrapper.classList.add('open')

      let contentsHeight = 50
      for (let i = 0, p; p = paragraphs[i]; i++) {
        contentsHeight += p.offsetHeight
      }

      setTimeout(() => {
        content.style.maxHeight = `${contentsHeight}px`
      }, 100)
    }
  }

  closeAllAccordions() {
    this.accordions.forEach((accordion) => {
      accordion.classList.remove('open')
    })
  }

  closeConcierge() {
    this.drawer.classList.remove('is-active')
    this.drawer.classList.remove('is-visible')
    this.mainWrapper.classList.remove('open-drawer')
    this.closest('html.js').style.overflow = null
    document.body.classList.remove('drawer-open')
  }

  scrollToAppointment() {
    const overflow = this.closest('.drawer__wrapper')
    overflow.scrollTo({ top: this.appointmentForm.offsetTop, behavior: 'smooth' })
  }
}

customElements.define("concierge-drawer", ConciergeDrawer)